<template>
  <el-dialog
    :model-value="isOpen"
    width="744px"
    @close="$emit('close')"
  >
    <h1 class="tw-mb-1.5">
      {{ $t('foreigners.basic_info.notifications_dialog_title') }}
    </h1>
    <span class="tw-text-xl tw-text-gray-dark">
      {{ $t('common.prepositions.for') }} {{ foreigner.first_name }} {{ foreigner.last_name }}
    </span>
    <div
      v-loading="isLoading"
      class="tw-gap-x-6 tw-grid md:tw-grid-cols-2 tw-mt-3"
    >
      <div
        v-for="notification in notifications"
        :key="notification.notification_type"
        class="tw-py-5 tw-border-b tw-border-gray"
      >
        <el-switch
          :model-value="notification.enabled"
          :active-text="$capitalize(notification.notification_type_name)"
          @change="(value) => editNotification({ notification, value })"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    ...mapState({
      foreigner: (state) => state.v2.admin.foreigners.foreigner.foreigner,
      notifications: (state) => state.v2.admin.foreigners.foreigner.notifications,
    }),
  },

  async mounted() {
    this.isLoading = true;
    this.loadNotifications();
    this.isLoading = false;
  },

  methods: {
    async loadNotifications() {
      await this.$store.dispatch('v2/admin/foreigners/foreigner/loadNotifications', this.foreigner.id);
    },
    async editNotification({ notification, value }) {
      notification.enabled = value;
      await this.$store.dispatch('v2/admin/foreigners/foreigner/editNotifications', {
        foreignerId: this.foreigner.id,
        notifications: this.notifications,
      });
      this.loadNotifications();
    },
  },
};
</script>
